/**
 * Module Federation (TDD §9.1, Chiến lược 5.7 — W11): shell + 4 remote theo cụm nghiệp vụ. Mỗi thư mục `apps/admin-console/src/features/<feature>`
 * thuộc đúng một cụm; remote của cụm expose `./<feature>/pages/<Page>`; shell nạp lười theo entitlement/quyền (route guard vẫn ở shell).
 * Tệp này thuần TS (không import) để dùng được cả trong vite.config (Node) lẫn runtime trình duyệt.
 */
export type Cluster = 'commerce' | 'supply' | 'engage' | 'platform';

/** feature (thư mục) → cụm. Thêm feature mới = thêm một dòng; ArchUnit phía web = test `federation.test.ts` kiểm mọi thư mục đều có cụm. */
export const FEATURE_CLUSTER: Record<string, Cluster> = {
  product: 'commerce', customer: 'commerce', pricing: 'commerce', credit: 'commerce', order: 'commerce', payment: 'commerce',
  supply: 'supply', inventory: 'supply', logistics: 'supply', production: 'supply', oem: 'supply',
  social: 'engage', loyalty: 'engage', care: 'engage', dms: 'engage', hr: 'engage', notify: 'engage', insight: 'engage',
  admin: 'platform', bpm: 'platform', connect: 'platform', file: 'platform', platform: 'platform',
  dashboard: 'platform',   // R5.9 — fbOps (Trung tâm vận hành F&B)
};

export const CLUSTERS: Cluster[] = ['commerce', 'supply', 'engage', 'platform'];
/** Tên remote trong Module Federation (phải trùng `name` ở vite.config của remote). */
export const remoteName = (c: Cluster) => `kovix_${c}`;
export const featuresOf = (c: Cluster): string[] => Object.entries(FEATURE_CLUSTER).filter(([, v]) => v === c).map(([k]) => k);

/**
 * Gói dùng chung — singleton để store/context chỉ có một bản giữa shell và remote (TDD §9.2: một nguồn sự thật trên trình duyệt).
 * `@kovix/shell-kit` giữ phiên/quyền, OIDC, instance HTTP, realtime; `@kovix/ui` giữ ToastContext.
 */
export const SHARED_SINGLETONS = ['react', 'react-dom', 'react/jsx-runtime', '@tanstack/react-query', '@tanstack/react-router', 'zustand', '@kovix/ui', '@kovix/api-client', '@kovix/shell-kit'];
